import name_logo from "../../photos/name-logo.png";


import "./WelcomeBanner.css"
import DiscoverMore from "../../../Controller/Buttons/DiscoverMore";

const WelcomeBanner = () => {

    return (
        <div className= 'welcome-banner'>
            {/*<h2 className= 'caption'> Outreach & Capacity Building </h2>*/}
            <div className= 'welcome-info'>
                <div className= 'name-logo'>
                    <img src = {name_logo} alt = 'banner' />
                </div>
                {/*<p className= 'short-desc'> There are many of passages of lorem Ipsum, but the majori have</p>*/}
                <DiscoverMore name = "Discover More" url = "#about-us"/>
            </div>
        </div>
    )
}

export default WelcomeBanner;